export enum LocalStorageKey {
  'ACCOUNT_LOCKED' = 'lock',
}
